import { Controller } from "@hotwired/stimulus"

// Auto-returns a kiosk screen to the check-in home after a delay so an
// abandoned screen (e.g. the forgot-PIN QR code) doesn't sit there and hold up
// the line. The member can tap "I need more time" to restart the countdown.
export default class extends Controller {
  static targets = ["countdown"]
  static values = {
    returnUrl: { type: String, default: "/kiosk" },
    delay: { type: Number, default: 10000 },
  }

  connect() {
    this.start()
  }

  start() {
    this.clear()
    this.remaining = Math.ceil(this.delayValue / 1000)
    this.render()
    this.tickInterval = setInterval(() => this.tick(), 1000)
    this.timeout = setTimeout(() => this.redirect(), this.delayValue)
  }

  tick() {
    this.remaining -= 1
    this.render()
  }

  render() {
    if (this.hasCountdownTarget) {
      this.countdownTarget.textContent = Math.max(0, this.remaining)
    }
  }

  // Action: member taps "I need more time" — restart the countdown.
  extend() {
    this.start()
  }

  redirect() {
    this.clear()
    window.location.href = this.returnUrlValue
  }

  clear() {
    if (this.timeout) clearTimeout(this.timeout)
    if (this.tickInterval) clearInterval(this.tickInterval)
  }

  disconnect() {
    this.clear()
  }
}
